import { type MailboxInfo, getIndexerValueForMailboxInfo } from 'owa-client-types';
import { lazyGetM365Acquisition } from 'owa-m365-acquisitions/lib/lazyFunction';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { trace } from 'owa-trace';

export const COLLABORATION_PROTECTION_AGENT_TITLE_ID = 'T_adb0ffdb-3d92-b1e4-8e04-eba71bbbddfc';

const acquiredByMailbox = new Map<string, boolean>();

/**
 * Determines if the scan safety feature with Copilot should be shown for the given mailbox.
 * Uses lazyGetM365Acquisition with cache-first strategy. On the first call the acquisition
 * result may not yet be available (returns false); subsequent calls return the resolved value.
 * @param mailboxInfo
 * @returns True if the feature should be shown, false otherwise.
 */
export function shouldShowScanSafetyWithCopilot(mailboxInfo: MailboxInfo): boolean {
    if (
        !isGlobalFeatureEnabled('tri-scanSafetyWithCopilot') ||
        !isBizchatSidepaneEnabled(mailboxInfo)
    ) {
        return false;
    }

    const key = getIndexerValueForMailboxInfo(mailboxInfo);

    lazyGetM365Acquisition
        .importAndExecute(COLLABORATION_PROTECTION_AGENT_TITLE_ID, 'cache-first', mailboxInfo)
        .then(({ acquisition }) => {
            acquiredByMailbox.set(key, acquisition?.acquisitionState === 'Acquired');
        })
        .catch((error: Error) => {
            trace.warn(error.message);
        });

    return acquiredByMailbox.get(key) ?? false;
}
